import { inject } from '@angular/core';
import { CanActivateChildFn, Router, UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { TenantSystemNoticesFrontendService } from '../../tenant-features/system-notices/tenant-system-notices-frontend.service';
import { TenantWorkspaceLockService } from '../services/tenant-workspace-lock.service';

function slugFromUrl(url: string): string | null {
  const m = url.split('?')[0].match(/^\/t\/([^/]+)/);
  return m?.[1] ?? null;
}

/** Path segments after `/t/:slug/` (no leading/trailing slashes). */
function relativeTenantPath(url: string): string {
  const raw = url.split('?')[0];
  const m = raw.match(/^\/t\/[^/]+\/?(.*)$/);
  return (m?.[1] ?? '').replace(/^\/+|\/+$/g, '');
}

function isPathAllowedWhenLocked(relative: string): boolean {
  const parts = relative.split('/').filter(Boolean);
  if (parts.length === 0) return false;
  if (parts[0] === 'billing') return true;
  if (parts[0] === 'onboarding') return true;
  if (parts[0] === 'payment' && parts[1] === 'complete') return true;
  if (parts[0] === 'settings' && parts[1] === 'profile') return true;
  return false;
}

export const tenantWorkspaceLockGuard: CanActivateChildFn = (_route, state) => {
  const router = inject(Router);
  const lock = inject(TenantWorkspaceLockService);
  const notices = inject(TenantSystemNoticesFrontendService);
  const slug = slugFromUrl(state.url);
  if (!slug) return true;

  return notices.whenReadyForSlug(slug).pipe(
    map((): boolean | UrlTree => {
      if (!lock.isLocked()) return true;
      const rel = relativeTenantPath(state.url);
      if (isPathAllowedWhenLocked(rel)) return true;
      return router.createUrlTree(['/t', slug, 'billing', 'subscription']);
    }),
  );
};
